var extend = require("extend");

var _indexBy = function(obj, prop) {
  var result = {},
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key) && prop in obj[key]) {
      result[obj[key][prop]] = obj[key];
    }
  }
  return result;
};

var _omit = function(obj, cb) {
  var result = {},
    key;
  for (key in obj) {
    // cb returns true to omit element
    if (obj.hasOwnProperty(key) && !cb(obj[key])) {
      result[key] = obj[key];
    }
  }
  return result;
};

var _mapValues = function(obj, cb) {
  var result = {};
  Object.keys(obj).map(function(k) {
    result[k] = cb(obj[k], k);
  });
  return result;
};

var createUserProfileSteps = [
  {
    item: "welcome",
    text: "Welcome",
    subtext: "Next &#8212; Name",
    buttonText: "RSVP",
    save: "_noop"
  },
  {
    item: "name",
    text: "Name",
    subtext: "Next &#8212; Profile Photo",
    buttonText: "next",
    save: "setUserName"
  },
  {
    item: "email",
    text: "Email",
    subtext: "Next &#8212; RSVP",
    buttonText: "next",
    save: "setUserEmail"
  },
  {
    item: "rsvp",
    text: "RSVP",
    subtext: "Next &#8212; Dietary Restrictions",
    buttonText: "next",
    save: "setUserRSVP"
  },
  {
    item: "address",
    text: "Mailing Address",
    subtext: "Next &#8212; Relationship Status",
    buttonText: "next",
    save: "setUserAddress"
  },
  {
    item: "diet",
    text: "Dietary Restrictions",
    subtext: "Next &#8212; Hotel Accomodations",
    buttonText: "next",
    save: "setUserDietaryRestrictions",
    override: false
  },
  {
    item: "hotel",
    text: "Hotel Accommodations",
    subtext: "Next &#8212; Address",
    buttonText: "next",
    save: "setUserHotelNeeded",
    override: false
  },
  {
    item: "notes",
    text: "Other notes",
    subtext: "You can edit anything at anytime.",
    buttonText: "next",
    save: "setUserNotes",
    override: false,
    funQuestion: true
  },
  {
    item: "weddingTeam",
    text: "Who do you know?",
    subtext: "Next &#8212; RSVP",
    buttonText: "next",
    save: "setUserWeddingTeam",
    funQuestion: true
  },
  {
    item: "funFact",
    text: "How do you know...",
    subtext: "Next &#8212; Other Notes",
    buttonText: "next",
    save: "setUserFunFact",
    funQuestion: true
  },
  {
    item: "relationshipStatus",
    text: "Relationship Status",
    subtext: "Next &#8212; Fun Fact",
    buttonText: "next",
    save: "setUserRelationshipStatus",
    funQuestion: true
  },
  {
    item: "link",
    text: "Sign Up",
    subtext: "Blah Blah Blah Blah Blah",
    buttonText: "finish",
    save: "_noop",
    funQuestion: true
  }
];

createUserProfileSteps.forEach(function(step) {
  // if (step.item == "name" || step.item == "email") return;
  if (step.item != "profilePhoto") {
    step.save = "_noop";
  }
});

var EventQuestions = function(mgr) {
  var This = this;
  This._mgr = mgr;
  This._telemetry = This._mgr.getTelemetry().clone();
};

EventQuestions.prototype.getJoyRSVPQuestions = function() {
  return _indexBy(createUserProfileSteps, "item");
};

EventQuestions.prototype.getEnabledQuestions = function(
  customQuestions,
  overrides
) {
  var This = this;
  var joyRsvpQuestions = This.getJoyRSVPQuestions();

  //Convert raw custom questions into the format of navItem steps
  var customQuestionSteps = _mapValues(customQuestions || {}, function(q, key) {
    return {
      item: key,
      prefix: q.prefix,
      question: q.question,
      text: q.title,
      subtext: "Next &#8212; ",
      buttonText: "next",
      save: "setCustomQuestion",
      custom: true
    };
  });

  //question overrides,
  var joyOverrides = _mapValues(overrides || {}, function(override) {
    return {
      override: override
    };
  });

  //Universal set of all questions
  var allQuestions = extend(
    {},
    joyRsvpQuestions,
    customQuestionSteps,
    joyOverrides
  );

  //remove questions which have override as false,
  var enabledQuestions = _omit(allQuestions, function(q) {
    return q && "override" in q && q.override === false;
  });

  return enabledQuestions;
};

export { EventQuestions };
